<script setup>
import { ref, computed } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useThemesStore } from "@/stores/themes";
import { useUiStore } from "@/stores/ui";
import router from "@/router";
defineProps({
  closeModal: Function,
});

const themesStore = useThemesStore();
const uiStore = useUiStore();
const emit = defineEmits(["refresh"]);
const company_id = useCompanyStore().companyId;
const getModalAction = computed(() => uiStore.modalAction);
let description = ref(null);
let name = ref(null);
let isSubmitted = ref(false);

const resetStoreData = () => {
  uiStore.resetModalStore();
  name.value = null;
  description.value = null;
  isSubmitted.value = false;
};

const onSubmit = () => {
  isSubmitted.value = true;
  const data = {
    name: name.value,
    description: description.value,
    company_id,
  };

  themesStore
    .addTheme(data)
    .then((res) => {
      router.push("/themes/" + res.data.id);
      emit("refresh");
      resetStoreData();
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};
</script>

<template>
  <DModal v-if="getModalAction === 'add_theme'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Add Theme </template>

    <template #body>
      <div class="mb-3">
        <DInput
          label="Theme Name"
          :value="name"
          @input="name = $event.target.value"
          type="text"
          width="100%"
        />
      </div>

      <FloatLabel class="w-full mb-3">
        <PTextarea
          v-model="description"
          id="description"
          class="d-textarea resize-none h-105 w-full"
          autoResize
        />
        <label for="description">Description</label>
      </FloatLabel>
    </template>
    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            :disabled="!name || isSubmitted"
            @click="onSubmit"
            type="button"
            class="btn btn-primary add-button mr-30"
          >
            Add
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-secondary cancel-button"
          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
